import { render, staticRenderFns } from "./EmailTemplatesPage.vue?vue&type=template&id=42692a9f"
import script from "./EmailTemplatesPage.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplatesPage.vue?vue&type=style&index=0&id=42692a9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports